// Détails de chaque numéro pour la fenêtre « Plus d’infos sur ce numéro ».
// Sommaires : 01_ecosystem/revue-numeros-index.md, complétés depuis les sommaires imprimés.
// Généré par build_details.py ; modifier les accroches ici si besoin.
window.REVUE_DETAILS = {
 "1": {
  "accroche": "Le tout premier numéro de la Revue. Laurent Ozon dresse le portrait d’Elon Musk, Pierre-Antoine Plaquevent ouvre le dossier du CFR, le réseau de l’élite globaliste américaine, et Franck Pengam pose la question qui fâche : or ou dollar, où mettre son épargne ?",
  "articles": [
   [
    "Elon Musk : le libertarien le plus puissant du monde",
    "Laurent Ozon"
   ],
   [
    "Voitures électriques : fonçons-nous dans le mur ?",
    "Laurent Ozon"
   ],
   [
    "Un peu de fondamental : les valorisations restent élevées",
    "Andy Bussaglia"
   ],
   [
    "Géopolitique du globalisme : le Council on Foreign Relations (CFR)",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "L’aluminium à la croisée des chemins pour 2023",
    "Franck Pengam"
   ],
   [
    "Or ou dollar : quelle devise refuge pour 2023 ?",
    "Franck Pengam"
   ],
   [
    "Quel avenir pour un système monétaire indépendant des banques centrales ?",
    "Franck Pengam"
   ]
  ]
 },
 "2": {
  "accroche": "Pierre-Antoine Plaquevent enquête sur la géo-ingénierie et la militarisation du climat, Laurent Ozon se demande si les IA sont vraiment « intelligentes ». Côté argent, Franck Pengam passe en revue le nickel, le gaz, l’argent métal et l’essor du bitcoin en Afrique.",
  "articles": [
   [
    "Intelligence Artificielle : errare humanum est",
    "Laurent Ozon"
   ],
   [
    "Les IA sont-elles « intelligentes » ?",
    "Laurent Ozon"
   ],
   [
    "Géo-ingénierie : la militarisation et la manipulation géopolitique du climat",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "La remontée de l’offre de nickel favorise des perspectives à la baisse du prix jusqu’en 2025",
    "Franck Pengam"
   ],
   [
    "Pourquoi le prix du gaz baisse et quelles perspectives pour 2023 ?",
    "Franck Pengam"
   ],
   [
    "Métaux précieux : quelles perspectives pour le marché de l’argent ?",
    "Franck Pengam"
   ],
   [
    "Le rôle des cryptomonnaies Bitcoin (BTC) et Ripple (XRP) en Afrique : vers une adoption de masse ?",
    "Franck Pengam"
   ],
   [
    "Place aux tensions bancaires",
    "Andy Bussaglia"
   ]
  ]
 },
 "3": {
  "accroche": "Comment le Club Bilderberg a arrimé l’Europe à l’Atlantique : Pierre-Antoine Plaquevent remonte le fil. Laurent Ozon interroge la question climatique, et Franck Pengam se demande si la COP28 de Dubaï annonce la fin du pétrodollar.",
  "articles": [
   [
    "Écologie : le temps des choix",
    "Laurent Ozon"
   ],
   [
    "Écologie : la question climatique",
    "Laurent Ozon"
   ],
   [
    "Le Club Bilderberg et l’intégration atlantique de l’Europe",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "Synthèse financière",
    "Andy Bussaglia"
   ],
   [
    "Hausse du coût de l’électricité en Europe, quel impact sur le marché du zinc ?",
    "Franck Pengam"
   ],
   [
    "Vers la fin de la suprématie de Tesla ? La hausse du prix du lithium et ses conséquences",
    "Franck Pengam"
   ],
   [
    "COP28 à Dubaï : l’échec de la transition énergétique face aux énergies fossiles et la fin du pétrodollar ?",
    "Franck Pengam"
   ],
   [
    "L’investissement dans les diamants va-t-il être rentable en 2023 ?",
    "Franck Pengam"
   ]
  ]
 },
 "4": {
  "accroche": "Youssef Hindi décrit la guerre que les États-Unis mènent à l’Europe, Laurent Ozon l’implosion démographique qui suit l’explosion. Franck Pengam suit la course aux métaux critiques, du cobalt de la voiture « verte » au rôle des cryptomonnaies dans la guerre en Ukraine.",
  "articles": [
   [
    "Après l’explosion, l’implosion démographique",
    "Laurent Ozon"
   ],
   [
    "La stérilisation des sociétés complexes",
    "Laurent Ozon"
   ],
   [
    "La guerre des États-Unis contre l’Europe et l’avenir de l’État",
    "Youssef Hindi"
   ],
   [
    "Synthèse financière",
    "Andy Bussaglia"
   ],
   [
    "La Chine entre le charbon et la transition verte ?",
    "Franck Pengam"
   ],
   [
    "Investir dans les mines : la course aux métaux critiques",
    "Franck Pengam"
   ],
   [
    "Le cobalt ou la part d’ombre de la voiture verte",
    "Franck Pengam"
   ],
   [
    "Pourquoi les cryptomonnaies jouent-elles un rôle majeur dans la guerre entre la Russie et l’Ukraine ?",
    "Franck Pengam"
   ]
  ]
 },
 "5": {
  "accroche": "Xavier Moreau détaille les enjeux économiques et militaro-industriels de la guerre en Ukraine. Laurent Ozon analyse le populisme et les technologies de contrôle, Lucien Cerise le déclin anthropologique des Européens, et Franck Pengam fait le point sur les terres rares.",
  "articles": [
   [
    "Le populisme : une réaction immunitaire sous stress vital",
    "Laurent Ozon"
   ],
   [
    "Wokisme, immigration, LGBT : le déclin anthropologique des Européens",
    "Lucien Cerise"
   ],
   [
    "Les technologies de contrôle",
    "Laurent Ozon"
   ],
   [
    "Les enjeux économiques et militaro-industriels de la guerre en Ukraine",
    "Xavier Moreau"
   ],
   [
    "Quel marché pour les terres rares en 2023 et au-delà ?",
    "Franck Pengam"
   ],
   [
    "Perspectives sur le marché des métaux du groupe du platine en 2023",
    "Franck Pengam"
   ],
   [
    "Les minerais de fer face à la multiplication des projets d’exploitation",
    "Franck Pengam"
   ],
   [
    "Le rôle du Bitcoin et des cryptomonnaies en Amérique Latine",
    "Franck Pengam"
   ]
  ]
 },
 "6": {
  "accroche": "La crise des opiacés est-elle une nouvelle guerre de l’opium ? Laurent Ozon répond, puis montre comment nos sociétés vivent sous psychotropes. Pierre-Antoine Plaquevent pose les fondamentaux du globalisme, et Franck Pengam suit l’or face à la plus forte hausse des taux depuis 22 ans.",
  "articles": [
   [
    "La crise des opiacés : une nouvelle guerre de l’opium ?",
    "Laurent Ozon"
   ],
   [
    "Nos sociétés sous psychotropes",
    "Laurent Ozon"
   ],
   [
    "Les fondamentaux géopolitiques du globalisme (Première partie)",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "Faites attention au marché actions",
    "Andy Bussaglia"
   ],
   [
    "Fusions-acquisitions sur le marché de l’or",
    "Franck Pengam"
   ],
   [
    "L’or face à la plus grosse hausse des taux d’intérêt depuis 22 ans",
    "Franck Pengam"
   ],
   [
    "Pourquoi les banques centrales tardent-elles à adopter les CBDC ?",
    "Franck Pengam"
   ]
  ]
 },
 "7": {
  "accroche": "L’Occident peut-il perdre la guerre de quatrième génération ? Laurent Ozon ouvre ce numéro, suivi d’un dossier spécial sur la guerre économique atlantiste. Franck Pengam étudie la future monnaie commune des BRICS+ et un possible retour à l’étalon-or.",
  "articles": [
   [
    "L’Occident collectif perdra-t-il la guerre de quatrième génération ?",
    "Laurent Ozon"
   ],
   [
    "Hausse des taux : la fin du ponzi financier mondial basé sur la dette ?",
    "Andy Bussaglia"
   ],
   [
    "La monnaie commune des BRICS+ : vers un retour à l’étalon-or ?",
    "Franck Pengam"
   ],
   [
    "Dossier spécial : la guerre économique atlantiste",
    "Mac Guffin"
   ],
   [
    "Les enjeux fiscaux derrière les cryptomonnaies",
    "Franck Pengam"
   ]
  ]
 },
 "8": {
  "accroche": "Jean-Maxime Corneille retrace cinq siècles de subversion internationaliste. Pierre-Antoine Plaquevent replace la guerre entre Israël et Gaza sur la carte des routes de la soie, et Franck Pengam décrit les BRICS+ comme un ordre mondial alternatif en train de naître.",
  "articles": [
   [
    "Cinq siècles de subversion internationaliste",
    "Jean-Maxime Corneille"
   ],
   [
    "Israël vs Gaza : une nouvelle guerre le long des routes de la soie",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "Émotion et dépression collective à l’heure de l’effondrement",
    "Laurent Ozon"
   ],
   [
    "La plus grosse baisse obligataire depuis un siècle",
    "Andy Bussaglia"
   ],
   [
    "BRICS+ : vers le nouvel ordre mondial alternatif",
    "Franck Pengam"
   ]
  ]
 },
 "9": {
  "accroche": "Pierre-Antoine Plaquevent dévoile le vrai visage d’Henry Kissinger, et Jean-Maxime Corneille montre ce que doit être l’État face à la subversion internationaliste. Franck Pengam annonce un nouveau supercycle des métaux « sales » dont dépend l’énergie dite propre.",
  "articles": [
   [
    "Une leçon civilisationnelle : l’État, la Politique et le sens de l’État face à la Subversion internationaliste",
    "Jean-Maxime Corneille"
   ],
   [
    "Les fondamentaux continuent de se dégrader en 2024",
    "Andy Bussaglia"
   ],
   [
    "Vers un nouveau supercycle des métaux sales de l’énergie propre",
    "Franck Pengam"
   ],
   [
    "Le vrai visage d’Henry Kissinger",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "La décentralisation ou la destruction des intermédiaires",
    "Franck Pengam"
   ]
  ]
 },
 "10": {
  "accroche": "Caroline Galactéros signe « Occident : le cimetière des rêves brisés ». Thibault Kerlirzin remonte aux origines de l’Agenda 2030, de Maurice Strong à la Charte de la Terre, Laurent Ozon décrit l’avènement de l’État total, et Philippe Herlin passe en revue les placements de 2024.",
  "articles": [
   [
    "Occident : le cimetière des rêves brisés",
    "Caroline Galactéros"
   ],
   [
    "L’avènement de l’État total",
    "Laurent Ozon"
   ],
   [
    "Derrière l’Agenda 2030 : de Maurice Strong à la Charte de la Terre",
    "Thibault Kerlirzin"
   ],
   [
    "« Subversion idéologique » : le rôle crucial des idéologies derrière le mondialisme",
    "Jean-Maxime Corneille"
   ],
   [
    "Quels placements pour 2024 ?",
    "Philippe Herlin"
   ],
   [
    "Les plus grands risques mondiaux pour les marchés en 2024",
    "Andy Bussaglia"
   ],
   [
    "La décentralisation en pratique",
    "Franck Pengam"
   ]
  ]
 },
 "11": {
  "accroche": "Marc Gabriel Draghi décortique la ville connectée du Great Reset, pensée pour nous contrôler tous. Jean-Maxime Corneille poursuit son enquête sur les idéologies derrière le mondialisme, et Philippe Herlin et Franck Pengam se demandent si 2024 sera l’année du bitcoin.",
  "articles": [
   [
    "Smart City et Great Reset : des villes pour nous contrôler tous",
    "Marc Gabriel Draghi"
   ],
   [
    "« Subversion idéologique » : le rôle crucial des idéologies derrière le mondialisme (suite)",
    "Jean-Maxime Corneille"
   ],
   [
    "La révolution occidentale de la pratique médicale",
    "Laurent Ozon"
   ],
   [
    "Cocktail explosif : les excès de dette combinée à l’exubérance des marchés actions",
    "Andy Bussaglia"
   ],
   [
    "2024, une bonne année pour le bitcoin ?",
    "Philippe Herlin"
   ],
   [
    "Nouveau bull run crypto en 2024 : mirage ou véritable explosion des prix à venir ?",
    "Franck Pengam"
   ]
  ]
 },
 "12": {
  "accroche": "Le numéro anniversaire de la Revue. Le général Dominique Delawarde explique pourquoi « la Russie a gagné », Jean-Maxime Corneille montre le rôle de la France dans la riposte des BRICS+, et Philippe Herlin se demande s’il existe encore un marché immobilier.",
  "articles": [
   [
    "Édito anniversaire « 1 an déjà pour la revue »",
    "Franck Pengam"
   ],
   [
    "La Russie a gagné parce que…",
    "Dominique Delawarde"
   ],
   [
    "La France, initiatrice de la riposte des BRICS+ au Nouvel Ordre Mondial",
    "Jean-Maxime Corneille"
   ],
   [
    "Existe-t-il encore un « marché immobilier » ?",
    "Philippe Herlin"
   ],
   [
    "Les actions chinoises et les minières face à la bulle mondiale ?",
    "Andy Bussaglia"
   ],
   [
    "Défaillances et renouveaux",
    "Laurent Ozon"
   ],
   [
    "Le Bitcoin au sommet : quel impact sur l’or en tant que valeur refuge de référence ?",
    "Franck Pengam"
   ]
  ]
 },
 "13": {
  "accroche": "D’où vient l’Ukraine, et où va-t-elle ? Dimitri de Kochko répond, pendant que Pierre-Antoine Plaquevent retrace la longue guerre contre l’Eurasie, de Mackinder à nos jours. François Martin affirme que « l’URSS se trouve à l’Ouest ».",
  "articles": [
   [
    "D’où vient et où va l’Ukraine ?",
    "Dimitri de Kochko"
   ],
   [
    "L’URSS se trouve à l’Ouest",
    "François Martin"
   ],
   [
    "La longue guerre contre l’Eurasie de Mackinder à nos jours",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "L’alimentation, entre pouvoir d’achat et santé",
    "Philippe Herlin"
   ],
   [
    "Rallye sur l’or et top de marché boursier ?",
    "Andy Bussaglia"
   ],
   [
    "Les promesses du biomimétisme",
    "Laurent Ozon"
   ],
   [
    "Les semi-conducteurs : un enjeu géostratégique pour les cryptos",
    "Franck Pengam"
   ]
  ]
 },
 "14": {
  "accroche": "Youssef Hindi donne les clés pour comprendre le conflit israélo-palestinien. Jean-Michel Vernochet montre que wokisme et transhumanisme sont les deux faces d’une même idéologie, et Franck Pengam décrit MIR, le système de paiement russe pensé contre Swift.",
  "articles": [
   [
    "Comprendre le conflit israélo-palestinien",
    "Youssef Hindi"
   ],
   [
    "Métal jaune : le plan suit son cours !",
    "Andy Bussaglia"
   ],
   [
    "Wokisme et transhumanisme, les deux faces d’une même idéologie totalitaire",
    "Jean-Michel Vernochet"
   ],
   [
    "Domestication : l’enjeu final",
    "Laurent Ozon"
   ],
   [
    "L’argent métal au cœur du Great Reset : transition verte globale et 4e Révolution Industrielle",
    "Marc Gabriel Draghi"
   ],
   [
    "MIR : le système de paiement russe contre Swift",
    "Franck Pengam"
   ]
  ]
 },
 "15": {
  "accroche": "Lucien Cerise distingue les deux antisionismes, Jean-Maxime Corneille explique pourquoi la guerre est « bonne pour les affaires ». François-Xavier Consoli fait le portrait de Walter Lippmann, l’un des hommes les plus influents du XXᵉ siècle, et Philippe Herlin applique au bitcoin le modèle stock/flux.",
  "articles": [
   [
    "Les deux antisionismes",
    "Lucien Cerise"
   ],
   [
    "Marchés en ébullition : l’illusion d’une économie en pleine santé",
    "Andy Bussaglia"
   ],
   [
    "Mondialisme belliciste : pourquoi la guerre est « bonne pour les affaires » ?",
    "Jean-Maxime Corneille"
   ],
   [
    "Bitcoin : modèle stock/flux et prévision du cours",
    "Philippe Herlin"
   ],
   [
    "Walter Lippmann, l’un des hommes les plus influents du XXe siècle",
    "François-Xavier Consoli"
   ],
   [
    "Comprendre la psychologie évolutionniste",
    "Laurent Ozon"
   ]
  ]
 },
 "16": {
  "accroche": "Pierre Hillard remonte aux origines de la construction européenne et de la gouvernance mondiale. Dimitri de Kochko fait le point sur le front OTAN-Russie-Ukraine, « ni paix, ni guerre », et Laurent Ozon raconte la révolution bactérienne qui s’annonce en médecine.",
  "articles": [
   [
    "OTAN-Russie-Ukraine : ni Paix, ni Guerre !",
    "Dimitri de Kochko"
   ],
   [
    "L’antispécisme ou l’écologie paroxystique… et de la gouvernance mondiale",
    "Jean-Michel Vernochet"
   ],
   [
    "Aux origines de la construction européenne et de la gouvernance mondiale",
    "Pierre Hillard"
   ],
   [
    "La révolution bactérienne en médecine",
    "Laurent Ozon"
   ],
   [
    "Détérioration sans précédent dans l’histoire financière",
    "Andy Bussaglia"
   ],
   [
    "Les BRICS+ comme alternative à l’Empire financier",
    "Franck Pengam"
   ]
  ]
 },
 "17": {
  "accroche": "Que faut-il savoir des explosions nucléaires ? Gérard Chevrier l’explique, et le général Delawarde jauge les porte-avions dans les guerres du XXIᵉ siècle. Thibault Kerlirzin enquête sur Tavistock et John Rawlings Rees, Laurent Ozon sur Peter Thiel.",
  "articles": [
   [
    "Ce qu’il faut savoir des différents types d’explosions nucléaires",
    "Gérard Chevrier"
   ],
   [
    "Qui est la Sodexo, l’entreprise mondiale responsable de la malbouffe pendant les JO de Paris ?",
    "Claude Janvier"
   ],
   [
    "Les porte-avions dans les guerres du XXIe siècle",
    "Dominique Delawarde"
   ],
   [
    "Tavistock : John Rawlings Rees, le Maurice Strong de la santé mentale",
    "Thibault Kerlirzin"
   ],
   [
    "Peter Thiel, et la dialectique des contraires",
    "Laurent Ozon"
   ],
   [
    "Les minières surperforment généralement le cours de l’or",
    "Andy Bussaglia"
   ],
   [
    "Le Bitcoin, nouvelle réserve stratégique des banques centrales ?",
    "Franck Pengam"
   ]
  ]
 },
 "18": {
  "accroche": "Une édition spéciale sur la nouvelle ère Trump : Franck Pengam se demande si elle ouvre un ordre multipolaire. Pierre Hillard décrit l’empire loubavitch, Claude Janvier la psychiatrie mise au service de la police de la pensée, et Gérard Chevrier montre que notre arsenal nucléaire ne protège pas les civils.",
  "articles": [
   [
    "La nouvelle ère Trump : vers un Nouvel Ordre Multipolaire ?",
    "Franck Pengam"
   ],
   [
    "La Psychiatrie au service de la police de la pensée",
    "Claude Janvier"
   ],
   [
    "Notre arsenal nucléaire ne protège pas la population civile de notre pays",
    "Gérard Chevrier"
   ],
   [
    "L’Empire loubavitch ou le mondialisme en action",
    "Pierre Hillard"
   ],
   [
    "La première baisse des taux d’intérêt depuis le Covid-19",
    "Andy Bussaglia"
   ],
   [
    "On baisse les taux, mais ils montent !",
    "Andy Bussaglia"
   ],
   [
    "Les champignons vont nous faire changer",
    "Laurent Ozon"
   ],
   [
    "Pourquoi il faut vendre ses ethers et basculer sur le bitcoin",
    "Philippe Herlin"
   ]
  ]
 },
 "19": {
  "accroche": "Gérard Chevrier revient sur les raisons de l’assassinat de John F. Kennedy. Jean-Michel Vernochet analyse la chute de Damas et ouvre « les cahiers du wokisme », et Laurent Ozon explique ce qu’il appelle le « Grand Soir » quantique.",
  "articles": [
   [
    "Chute de Damas : une OPA otano-sioniste sur la Syrie",
    "Jean-Michel Vernochet"
   ],
   [
    "Les raisons de l’assassinat du président John F. Kennedy",
    "Gérard Chevrier"
   ],
   [
    "L’idéologie mortifère des faiseurs de guerres",
    "Claude Janvier"
   ],
   [
    "De la rigueur dans ce contexte euphorique des marchés",
    "Andy Bussaglia"
   ],
   [
    "La France dans les BRICS+",
    "Franck Pengam"
   ],
   [
    "Auto-érotisme à la crèche",
    "Marion Sigaut"
   ],
   [
    "Les cahiers du wokisme",
    "Jean-Michel Vernochet"
   ],
   [
    "Le « Grand Soir » quantique",
    "Laurent Ozon"
   ]
  ]
 },
 "20": {
  "accroche": "Laurent Ozon raconte comment la CIA s’est métastasée dans la Silicon Valley. Sylvain Ferreira montre comment l’armée russe s’adapte pour vaincre en Ukraine, Marc Gabriel Draghi fait d’Israël la vitrine du Great Reset, et Franck Pengam livre sa géopolitique de l’or 2025.",
  "articles": [
   [
    "Hommage au peuple syrien et à son pays qui fut laïc, moderne, et progressiste",
    "Claude Janvier"
   ],
   [
    "L’armée russe en Ukraine : s’adapter pour vaincre (1re partie)",
    "Sylvain Ferreira"
   ],
   [
    "Quatre facteurs pour une révolution",
    "Alexandre Juving-Brunet"
   ],
   [
    "Israël : vitrine du Great Reset et de la 4e Révolution Industrielle",
    "Marc Gabriel Draghi"
   ],
   [
    "Israël et l’AIPAC ont choisi Donald Trump pour détruire l’Iran",
    "Gérard Chevrier"
   ],
   [
    "Comment la CIA s’est métastasée dans la Silicon Valley",
    "Laurent Ozon"
   ],
   [
    "Géopolitique de l’Or 2025",
    "Franck Pengam"
   ],
   [
    "Les 3 investissements du mois",
    "Franck Pengam"
   ]
  ]
 },
 "21": {
  "accroche": "François Martin explique « l’erreur de l’Occident ». Pierre-Antoine Plaquevent enquête sur le projet de reconstruction du Temple de Jérusalem, Laurent Michelon sur la voie médiane de la diplomatie chinoise, et Dimitri de Kochko fait la part des espoirs et des illusions autour des BRICS.",
  "articles": [
   [
    "L’erreur de l’Occident",
    "François Martin"
   ],
   [
    "La voie médiane, socle de la diplomatie chinoise",
    "Laurent Michelon"
   ],
   [
    "L’armée russe à l’épreuve de la guerre en Ukraine (2de partie) : l’année 2024",
    "Sylvain Ferreira"
   ],
   [
    "Messianisme et géopolitique : Israël et la reconstruction du Temple de Jérusalem",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "BRICS : entre espoirs et illusions",
    "Dimitri de Kochko"
   ],
   [
    "Guerre terroriste, terreur d’État ou désaxés marginaux tueurs à la sauvette ?",
    "Jean-Michel Vernochet"
   ],
   [
    "Une configuration jamais vue pour démarrer 2025",
    "Andy Bussaglia"
   ],
   [
    "Les 3 investissements du mois",
    "Franck Pengam"
   ]
  ]
 },
 "22": {
  "accroche": "Laurent Ozon remonte aux origines profondes des néoconservateurs. Sophie Lefeez se demande si Trump obtiendra de l’OTAN 5 % du PIB pour la défense, et Claude Janvier pose la question : l’OMS est-elle devenue une organisation mafieuse de la santé ?",
  "articles": [
   [
    "Trump et l’OTAN : vers 5 % du PIB pour la défense ?",
    "Sophie Lefeez"
   ],
   [
    "« Hamburger hill » ou l’impasse du « Body count »",
    "Sylvain Ferreira"
   ],
   [
    "Photographies d’un bugburger",
    "Thibault Kerlirzin"
   ],
   [
    "L’Organisation mondiale de la Santé serait-elle devenue l’Organisation mafieuse de la Santé ?",
    "Claude Janvier"
   ],
   [
    "Le complexe militaro-industriel américano-israélien et la 4e révolution industrielle",
    "Marc Gabriel Draghi"
   ],
   [
    "Les origines profondes des néoconservateurs",
    "Laurent Ozon"
   ],
   [
    "Union européenne et bouclier démocratique contre les ingérences américaines",
    "Jean-Michel Vernochet"
   ],
   [
    "S’assurer d’être monté à bord du train avant le grand départ",
    "Andy Bussaglia"
   ],
   [
    "Les 3 placements du mois de mars 2025",
    "Franck Pengam"
   ]
  ]
 },
 "23": {
  "accroche": "Le numéro le plus rare de la collection. François Martin y décrit la guerre culturelle et civilisationnelle, Sylvain Ferreira la marine américaine face à la Chine, Laurent Ozon « l’iceberg néoconservateur », et Andy Bussaglia explique comment investir en période de chaos.",
  "articles": [
   [
    "La guerre culturelle et civilisationnelle",
    "François Martin"
   ],
   [
    "Quelle marine américaine pour affronter la Chine ?",
    "Sylvain Ferreira"
   ],
   [
    "Tenus à l’écart des négociations sur l’Ukraine, les européens l’ont bien cherché",
    "Roland Hureaux"
   ],
   [
    "Révolution woke / Contre-Révolution",
    "Jean-Michel Vernochet"
   ],
   [
    "L’iceberg néoconservateur. La ruée vers l’État",
    "Laurent Ozon"
   ],
   [
    "Le complexe militaro-industriel américano-israélien",
    "Marc Gabriel Draghi"
   ],
   [
    "L’innovation à tout prix : quelle pertinence à la course au high-tech ? (1re partie)",
    "Sophie Lefeez"
   ],
   [
    "Investir en période de chaos",
    "Andy Bussaglia"
   ],
   [
    "Les 3 courtiers du mois d’avril 2025",
    "Franck Pengam"
   ]
  ]
 },
 "24": {
  "accroche": "Thibault Kerlirzin réunit des fragments sur le Club de Rome, Laurent Ozon démonte le grand mythe de la conquête spatiale. Pierre-Antoine Plaquevent et Youssef Hindi cosignent une enquête sur le projet de Troisième Temple, et Franck Pengam explique comment investir dans le nouveau désordre mondial.",
  "articles": [
   [
    "Une flotte en mutation : la lutte pour la modernisation",
    "Sylvain Ferreira"
   ],
   [
    "Fragments sur le Club de Rome",
    "Thibault Kerlirzin"
   ],
   [
    "Épuration ethnique et construction du Troisième Temple",
    "Pierre-Antoine Plaquevent et Youssef Hindi"
   ],
   [
    "Conquête spatiale : le Grand mythe !",
    "Laurent Ozon"
   ],
   [
    "L’innovation à tout prix : quelle pertinence à la course au high-tech ? (2de partie)",
    "Sophie Lefeez"
   ],
   [
    "Les marchés ont horreur de l’incertitude",
    "Andy Bussaglia"
   ],
   [
    "Investir dans le nouveau désordre mondial",
    "Franck Pengam"
   ]
  ]
 },
 "25": {
  "accroche": "Laurent Ozon décrit « l’iceberg néoconservateur », de victoire en victoire jusqu’à la défaite. Sylvain Ferreira jauge les matériels de la Bundeswehr en Ukraine, Dimitri de Kochko avance la seule solution pour la paix, et Sakari Linden montre comment la Finlande, oasis de stabilité de la guerre froide, devient un champ de bataille potentiel.",
  "articles": [
   [
    "Les performances des matériels de la Bundeswehr en Ukraine",
    "Sylvain Ferreira"
   ],
   [
    "Paix en Ukraine : une seule solution !",
    "Dimitri de Kochko"
   ],
   [
    "L’iceberg néoconservateur : de victoire en victoire jusqu’à la défaite",
    "Laurent Ozon"
   ],
   [
    "Les programmes spatiaux secrets : origine historique et terrestre des soucoupes volantes d’après Michael Salla",
    "Sophie Lefeez"
   ],
   [
    "Pas de doute, ce sont bien les marchés qui font la politique",
    "Andy Bussaglia"
   ],
   [
    "La Finlande : d’une oasis de stabilité de la guerre froide à un champ de bataille potentiel pour la défense du monde unipolaire",
    "Sakari Linden"
   ],
   [
    "Croissance et Valeur : deux philosophies d’investissement à l’épreuve du temps",
    "Franck Pengam"
   ]
  ]
 },
 "26": {
  "accroche": "Francis Lalanne signe une lettre ouverte à la Représentation nationale. Laurent Brayard et Sylvain Ferreira font le point sur la guerre en Ukraine, Jean-Michel Vernochet décrit Gaza comme le théâtre de la guerre cognitive, et Laurent Ozon annonce la révolution des intelligences.",
  "articles": [
   [
    "Lettre ouverte à la Représentation nationale",
    "Francis Lalanne"
   ],
   [
    "Conflit en Ukraine, situation et perspectives",
    "Laurent Brayard"
   ],
   [
    "Ukraine : bilan de l’offensive d’hiver 2025 de l’armée russe",
    "Sylvain Ferreira"
   ],
   [
    "Gaza : théâtre de la guerre cognitive",
    "Jean-Michel Vernochet"
   ],
   [
    "Le problème métapolitique d’une Europe stratégique",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "La propulsion électrogravitique basée sur l’effet Biefeld-Brown",
    "Sophie Lefeez"
   ],
   [
    "La révolution des intelligences",
    "Laurent Ozon"
   ],
   [
    "Une période de profonds changements",
    "Andy Bussaglia"
   ],
   [
    "L’été, le moment idéal pour repenser sa stratégie patrimoniale",
    "Franck Pengam"
   ]
  ]
 },
 "27": {
  "accroche": "Xavier Moreau revient sur le MH-17, « le père de tous les mensonges ». Pierre-Antoine Plaquevent retrace les étapes de l’hégémonie nucléaire d’Israël depuis 1939, Jean-Michel Vernochet tient le journal de la guerre des 12 jours, et Sophie Lefeez se penche sur le devenir du programme nazi de soucoupes volantes.",
  "articles": [
   [
    "MH-17 : le père de tous les mensonges",
    "Xavier Moreau"
   ],
   [
    "Les leçons militaires de la guerre à Gaza (2023-2024)",
    "Sylvain Ferreira"
   ],
   [
    "Le texticule du mois : Démocratie et théocratie au Moyen-Orient…",
    "Alain Soral"
   ],
   [
    "De 1939 à nos jours : Israël et les étapes de l’hégémonie nucléaire",
    "Pierre-Antoine Plaquevent"
   ],
   [
    "Israël vs Iran : journal de la guerre des 12 jours",
    "Jean-Michel Vernochet"
   ],
   [
    "Le devenir du programme nazi de soucoupes volantes après la guerre",
    "Sophie Lefeez"
   ],
   [
    "Encore une minute, monsieur le Bourreau",
    "Andy Bussaglia"
   ],
   [
    "Votre plan hors système… avant le grand verrouillage financier",
    "Franck Pengam"
   ]
  ]
 },
 "28": {
  "accroche": "En bombardant la Serbie en 1999, l’OTAN a ruiné son crédit moral : Laurent Artur du Plessis le démontre. Jean-Michel Vernochet décrit une planète malade du progrès, Laurent Ozon les ressorts du neuromarketing, et Franck Pengam se demande si le bitcoin est devenu une arme de domination américaine.",
  "articles": [
   [
    "1999 : en bombardant la Serbie, l’OTAN a ruiné son crédit moral",
    "Laurent Artur du Plessis"
   ],
   [
    "Le texticule du mois : Incohérence globale ou stratégie volontaire ?",
    "Alain Soral"
   ],
   [
    "Pollution chimique globale : la planète est malade du progrès",
    "Jean-Michel Vernochet"
   ],
   [
    "La manufacture du consentement : le star system remplacé par les « entrepren-acteurs »",
    "Laurent Michelon"
   ],
   [
    "La question de la balance des paiements américaine",
    "Éric Grémont"
   ],
   [
    "Le Bitcoin : une arme de domination américaine ? Ou comment saboter l’Empire pour mieux le sauver",
    "Franck Pengam"
   ],
   [
    "Neuromarketing : tromper et pénétrer les sphères d’acceptabilité des humains",
    "Laurent Ozon"
   ],
   [
    "La soucoupe volante grand public d’Otis Carr : histoire vraie ou canular ?",
    "Sophie Lefeez"
   ],
   [
    "Contrôles des capitaux 2026 : les 3 échappatoires légales avant la fermeture",
    "Franck Pengam"
   ]
  ]
 }
};
